import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { AxiosResponse, isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export interface PostGatewayIsAnnouncedPayload {
  onboarding_key: string;
}

export interface PostGatewayIsAnnouncedResponse {
  is_announced: boolean;
  is_onboarded: boolean;
}

export const postGatewayIsAnnounced = async (
  namespace: string,
  onboardingKey: string,
): Promise<AxiosResponse<PostGatewayIsAnnouncedResponse>> => {
  const url = clientConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.post<PostGatewayIsAnnouncedResponse>(
      `${url}/api/v3/ns/${namespace}/gateways/is-announced`,
      { onboarding_key: onboardingKey } satisfies PostGatewayIsAnnouncedPayload,
      { headers },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw err;
    }

    throw new Error(
      "An unexpected error occurred while checking gateway announcement.",
    );
  }
};
